import { styled, Grid, Box } from '@mui/material';

export const FolderListItemContent = styled(Grid, { shouldForwardProp: prop => !['colors'].includes(prop) })(({ theme, colors }) => ({
  position: 'relative',
  minHeight: theme.spacing(5),
  padding: theme.spacing(2),
  background: `linear-gradient(to right, #FFF 50%, ${
    colors.offerColor
      ? colors.offerColor
      : colors.folderColor
      ? colors.folderColor
      : colors.facilityColor
      ? colors.facilityColor
      : '#EEEEEE'
  } 90%)`,
  '&:hover': {
    background: `linear-gradient(to right, #FFF 100%, ${
      colors.offerColor
        ? colors.offerColor
        : colors.folderColor
        ? colors.folderColor
        : colors.facilityColor
        ? colors.facilityColor
        : '#EEEEEE'
    } 0%) !important`
  }
}));

export const FoldersListWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2)
}));

export const FolderListWrapper = styled(Grid)(({ theme }) => ({
  flexDirection: 'column',
  gap: theme.spacing(2)
}));

export const FolderAssetImage = styled('img')(() => ({
  height: '100%',
  marginLeft: 'auto',
  marginRight: 'auto',
  width: '100%',
  objectFit: 'contain',
  maxHeight: '130px',
  display: 'block'
}));
